// src/features/contactsSlice.js
import { createSlice } from '@reduxjs/toolkit';
import { fatchNewUser, fatchUser, fetchContacts, fetchConversationById, telegramLogin, telegramSendmessages, telegramVerifyOTP, tgDisconnect, tgRealTime, tgSendFile } from './telegramThunk';


const telegramSlice = createSlice({
    name: 'contacts',
    initialState: {
        contacts: [],
        conversation: null,
        status: 'idle',
        error: null,

        fetchContactsloading: null,
        fetchContactsError: null,
        fetchContactsFullfill: null,

        telegramLoginloading: null,
        telegramLoginError: null,
        telegramLoginFullfill: null,

        telegramVerifyOTPloading: null,
        telegramVerifyOTPError: null,
        telegramVerifyOTPFullfill: null,

        fatchUserloading: null,
        fatchUserError: null,
        fatchUserFullfill: null,
        
        fatchNewUserloading: null,
        fatchNewUserError: null,
        fatchNewUserFullfill: null,
        
        fetchConversationloading: null,
        fetchConversationError: null,
        fetchConversationFullfill: null,

        tgSendmessagesloading: null,
        tgSendmessagesError: null,
        tgSendmessagesFullfill: null,

        tgSendFileloading: null,
        tgSendFileError: null,
        tgSendFileFullfill: null,

        tgRealTimeloading: null,
        tgRealTimeFullfill: null,
        tgRealTimeError: null,

        tgDisconnectloading: null,
        tgDisconnectError: null,
        tgDisconnectFullfill: null
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchContacts.pending, (state) => {
                state.fetchContactsloading = true;
            })
            .addCase(fetchContacts.fulfilled, (state, action) => {
                state.fetchContactsloading = false;
                state.fetchContactsFullfill = action.payload;
            })
            .addCase(fetchContacts.rejected, (state, action) => {
                state.fetchContactsloading = false;
                state.fetchContactsError = action.payload;
            })
            .addCase(telegramLogin.pending, (state) => {
                state.telegramLoginloading = true;
            })
            .addCase(telegramLogin.fulfilled, (state, action) => {
                state.telegramLoginloading = false;
                state.telegramLoginFullfill = action.payload;
            })
            .addCase(telegramLogin.rejected, (state, action) => {
                state.telegramLoginloading = false;
                state.telegramLoginError = action.payload;
            })
            .addCase(telegramVerifyOTP.pending, (state) => {
                state.telegramVerifyOTPloading = true;
            })
            .addCase(telegramVerifyOTP.fulfilled, (state, action) => {
                state.telegramVerifyOTPloading = false;
                state.telegramVerifyOTPFullfill = action.payload;
            })
            .addCase(telegramVerifyOTP.rejected, (state, action) => {
                state.telegramVerifyOTPloading = false;
                state.telegramVerifyOTPError = action.payload;
            })

            .addCase(fatchUser.pending, (state) => {
                state.fatchUserloading = true;
            })
            .addCase(fatchUser.fulfilled, (state, action) => {
                state.fatchUserloading = false;
                state.fatchUserFullfill = action.payload;
            })
            .addCase(fatchUser.rejected, (state, action) => {
                state.fatchUserloading = false;
                state.fatchUserError = action.payload;
            })

            .addCase(fatchNewUser.pending, (state) => {
                state.fatchNewUserloading = true;
            })
            .addCase(fatchNewUser.fulfilled, (state, action) => {
                state.fatchNewUserloading = false;
                state.fatchNewUserFullfill = action.payload;
            })
            .addCase(fatchNewUser.rejected, (state, action) => {
                state.fatchNewUserloading = false;
                state.fatchNewUserError = action.payload;
            })

            .addCase(fetchConversationById.pending, (state) => {
                state.fetchConversationloading = true;
            })
            .addCase(fetchConversationById.fulfilled, (state, action) => {
                state.fetchConversationloading = false;
                state.fetchConversationFullfill = action.payload;
            })
            .addCase(fetchConversationById.rejected, (state, action) => {
                state.fetchConversationloading = false;
                state.fetchConversationError = action.payload;
            })
            .addCase(telegramSendmessages.pending, (state) => {
                state.tgSendmessagesloading = true;
            })
            .addCase(telegramSendmessages.fulfilled, (state, action) => {
                state.tgSendmessagesloading = false;
                state.tgSendmessagesFullfill = action.payload;
            })
            .addCase(telegramSendmessages.rejected, (state, action) => {
                state.tgSendmessagesloading = false;
                state.tgSendmessagesError = action.payload;
            })
            .addCase(tgSendFile.pending, (state) => {
                state.tgSendFileloading = true;
            })
            .addCase(tgSendFile.fulfilled, (state, action) => {
                state.tgSendFileloading = false;
                state.tgSendFileFullfill = action.payload;
            })
            .addCase(tgSendFile.rejected, (state, action) => {
                state.tgSendFileloading = false;
                state.tgSendFileError = action.payload;
            })

            .addCase(tgRealTime.pending, (state) => {
                state.tgRealTimeloading = true;
            })
            .addCase(tgRealTime.fulfilled, (state, action) => {
                state.tgRealTimeloading = false;
                state.tgRealTimeFullfill = action.payload;
            })
            .addCase(tgRealTime.rejected, (state, action) => {
                state.tgRealTimeloading = false;
                state.tgRealTimeError = action.payload;
            })
            .addCase(tgDisconnect.pending, (state) => {
                state.tgDisconnectloading = true;
            })
            .addCase(tgDisconnect.fulfilled, (state, action) => {
                state.tgDisconnectloading = false;
                state.tgDisconnectFullfill = action.payload;
            })
            .addCase(tgDisconnect.rejected, (state, action) => {
                state.tgDisconnectloading = false;
                state.tgDisconnectError = action.payload;
            });
    },
});

export default telegramSlice.reducer;
